export default class Animate
{
	constructor()
	{
		this.animate = document.querySelectorAll('.animate:not(.manual)');
		this.animate.length > 0 && this.initAnimations();
	}

	initAnimations()
	{
		document.body.classList.remove('preload');

		this.observer = new IntersectionObserver((objects) =>
		{
			for(let i = 0; i < objects.length; i++)
			{
				const object = objects[i];

				if(object.intersectionRatio > 0)
				{
					object.target.classList.add('active');
					this.observer.unobserve(object.target);
				}
			}
		},
		{
			rootMargin: '-100px 0px',
			threshold: 0.01
		});

		for(let i = 0; i < this.animate.length; i++)
			this.observer.observe(this.animate[i]);
	}
}
